import { API_ORIGIN } from '../services/api';

export const getImageUrl = (imagePath: string | null | undefined): string | null => {
  if (!imagePath) {
    return null;
  }

  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  if (imagePath.startsWith('blob:') || imagePath.startsWith('data:')) {
    return imagePath;
  }

  // Nest static /uploads is disabled; files are exposed at GET /api/uploads/stream/:filename
  const segments = imagePath.split(/[/\\]/).filter(Boolean);
  const fileName = segments.pop();
  if (!fileName) {
    return null;
  }

  const origin = API_ORIGIN || (typeof window !== 'undefined' ? window.location.origin : '');
  if (!origin) {
    return null;
  }

  return `${origin}/api/uploads/stream/${encodeURIComponent(fileName)}`;
};


export const getImageUrlWithFallback = (
  imagePath: string | null | undefined,
  fallback?: string
): string => {
  const url = getImageUrl(imagePath);
  return url || fallback || '/images/placeholder.jpg';
};

